import { format } from 'date-fns';
const APP_CONFIG = JSON.parse(localStorage.getItem('appConfig'));
import httpHelper from '../../../../utils/httpHelper';

const service = {
  async getCardEvents(params) {
    const endPoint = 'kv/card-event';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getDeviceVehicleRelationsSearchAll(params) {
    const endPoint = 'device-vehicle-relation/searchAll';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getCardEventsByVehicleId(params) {
    const { vehicleId, page, size } = params;
    const endPoint = `kv/card-event/findByVehicleId/${vehicleId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { page, size },
      'Bearer',
    );
    return result;
  },
  async getCardEventsByTransportationId(params) {
    const { transportationId, page, size, sort } = params;
    const endPoint = `kv/card-event/findByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { page, size, sort },
      'Bearer',
    );
    return result;
  },
  async getAllCardEventsByTransportationId(params) {
    const { transportationId } = params;
    const endPoint = `kv/card-event/findAllByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getDeviceEventsByTransportationId(params) {
    const { transportationId, page, size } = params;
    const endPoint = `device-event/findByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { page, size },
      'Bearer',
    );
    return result;
  },
  async getMotionEventsByTransportationId(params) {
    const { transportationId, page, size } = params;
    const endPoint = `motion-event/findByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { page, size },
      'Bearer',
    );
    return result;
  },
  async getAllCardEventByTransportationId(params) {
    const { transportationId } = params;
    const endPoint = `kv/card-event/findAllByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getAllCardEventByEmployeeId(id, params) {
    const { transportationId } = params;
    const endPoint = `kv/card-event/findAllEmployeeIdAndTimeBetween/${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getCardEventsByEmployeeId(id, params) {
    const endPoint = `kv/card-event/findByEmployeeIdAndTimeBetween/${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getAllDeviceEventByTransportationId(params) {
    const { transportationId } = params;
    const endPoint = `device-event/findAllByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getAllMotionEventByTransportationId(params) {
    const { transportationId } = params;
    const endPoint = `motion-event/findAllByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getMotionEventsByVehicleId(params) {
    const { vehicleId, page, size } = params;
    var beginDate = new Date(params.startDate);
    var beginNewDate = format(beginDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    var endDate = new Date(params.endDate);
    var endNewDate = format(endDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    const endPoint = `motion-event/findByVehicleIdAndTimeBetween`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {
        id: vehicleId,
        page: page,
        size: size,
        endDate: endNewDate,
        startDate: beginNewDate,
      },
      'Bearer',
    );
    return result;
  },
  async getDeviceEventsByVehicleId(params) {
    const { vehicleId, page, size } = params;
    var beginDate = new Date(params.startDate);
    var beginNewDate = format(beginDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    var endDate = new Date(params.endDate);
    var endNewDate = format(endDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    const endPoint = `device-event/findByVehicleIdAndTimeBetween`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {
        id: vehicleId,
        page: page,
        size: size,
        endDate: endNewDate,
        startDate: beginNewDate,
      },
      'Bearer',
    );
    return result;
  },
  async getDeviceEvents(params) {
    const endPoint = 'device-event';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },

  async getMotionEvents(params) {
    const endPoint = 'motion-event';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getCardEventswithSearch(params) {
    const endpoint = 'kv/card-event/search';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endpoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getLocation(coordinate) {
    const endPoint = `gh/reverse?coordinate=${coordinate}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
};

export default service;
